var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryIcon = function SvgHistoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.32 4.91a10.6 10.6 0 0 1 7.764-3.406c5.836 0 10.584 4.748 10.584 10.584S17.92 22.672 12.084 22.672 1.5 17.924 1.5 12.088h1.412c0 5.057 4.115 9.173 9.172 9.173s9.172-4.116 9.172-9.173-4.115-9.172-9.172-9.172a9.17 9.17 0 0 0-6.594 2.82h3.065v1.411H2.908V1.5h1.411zm7.058 7.178v-4.94h1.412v4.393l2.639 2.888-1.042.953z",
    clipRule: "evenodd"
  })));
};
export default SvgHistoryIcon;